module.exports = __webpack_public_path__ + "img/erp-logos_0019_sage50.473f057a.jpg";